export default "/images/vendor/@coreui/icons/svg/flag/cif-is.svg?929d0e346856f6438a9d93b282d96201";